import { isValidPhoneNumber } from '@components/forms/components/ContactMethodForm';
import ServiceUser from '@modules/ServiceModule/workspace/types/ServiceUser';
import maskPhoneNumber from './maskPhoneNumber';

const getDisplayName = (
  displayName: string,
  userByContactCenterUserId?: Record<string, ServiceUser>,
) => {
  if (!displayName) {
    return '';
  }

  if (displayName.startsWith('+')) {
    return maskPhoneNumber(displayName);
  }

  const [phoneNumber] = displayName.split(' ');
  const maskedPhoneNumber = maskPhoneNumber(phoneNumber);

  if (maskedPhoneNumber && isValidPhoneNumber(maskedPhoneNumber)) {
    return maskedPhoneNumber;
  }

  if (!displayName.startsWith('User')) {
    return displayName;
  }

  const contactCenterUserId = displayName
    .replace('User', '')
    .replace(/ *\([^)]*\) */g, '')
    .trim();

  if (userByContactCenterUserId) {
    const user = userByContactCenterUserId[contactCenterUserId];
    if (user) {
      return user.name;
    }
    // Sometimes the display name will be in short format like `da91c5d2-a`
    // instead of `da91c5d2-a208-4c1a-a733-9e72d9cb0f51`. See CCP-3946 for details.
    // So we need to find the user by checking if the contactCenterUserId is included in the user's contactCenterUserId.

    for (const ccUserId of Object.keys(userByContactCenterUserId)) {
      if (ccUserId.includes(contactCenterUserId)) {
        return userByContactCenterUserId[ccUserId].name;
      }
    }
  }
  return displayName;
};

export default getDisplayName;
